import debounce from "lodash.debounce";
import fetchCountries from "./fetchCountries.js";
import { alert } from "@pnotify/core";
import "@pnotify/core/dist/PNotify.css";
import "@pnotify/core/dist/BrightTheme.css";

const input = document.querySelector("#search-box");
const container = document.querySelector("#country-container");

input.addEventListener("input", debounce(onSearch, 500));

function onSearch(e) {
  const searchQuery = e.target.value.trim();

  if (!searchQuery) {
    container.innerHTML = "";
    return;
  }

  fetchCountries(searchQuery)
    .then((countries) => {
      if (countries.length > 10) {
        alert({ text: "MANY COUNTRIES, MORE LETTERS!!!😡" });
        container.innerHTML = "";
        return;
      }

      if (countries.length >= 2 && countries.length <= 10) {
        renderCountryList(countries);
        return;
      }

      if (countries.length === 1) {
        renderCountryInfo(countries[0]);
      }
    })
    .catch(() => {
      alert({ text: "SEARCH ERROR!!!😡" });
      container.innerHTML = "";
    });
}

function renderCountryList(countries) {
  const markup = countries.map((c) => `<p>${c.name}</p>`).join("");
  container.innerHTML = markup;
}

function renderCountryInfo(country) {
  container.innerHTML = `
    <h2>${country.name}</h2>
    <p><b>capital:</b> ${country.capital}</p>
    <p><b>population:</b> ${country.population}</p>
    <p><b>languages:</b> ${country.languages.map((l) => l.name).join(", ")}</p>
    <img src="${country.flag}" alt="${country.name}" width="300"/>
  `;
}
